'use client';

export default function ReviewsIoWidget() {
  return (
    <a
      target='_blank'
      href='https://www.reviews.co.uk/company-reviews/store/yayyay-ltd'
      title='Reviews.io Yay Reviews'
    >
      <img src='https://media.reviews.co.uk/badge/yayyay-ltd.png' />
    </a>
  );
}
